<script>
  export default{
    name : 'EndorseLobbyIcon'
  }
</script>
<template>
  <g>
    <path d="M10 0C4.48603 0 0 4.48591 0 9.99995C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 9.99995C20 4.48591 15.5141 0 10 0ZM15.7422 8.31087L9.45969 14.5933C9.19255 14.8605 8.83746 15.0075 8.45972 15.0075C8.08198 15.0075 7.72688 14.8605 7.45975 14.5933L4.25782 11.3914C3.99069 11.1243 3.84356 10.7692 3.84356 10.3915C3.84356 10.0136 3.99069 9.65852 4.25782 9.39139C4.52485 9.12426 4.87995 8.97713 5.25779 8.97713C5.63553 8.97713 5.99073 9.12426 6.25776 9.3915L8.45961 11.5932L13.742 6.31084C14.0092 6.04371 14.3643 5.89669 14.742 5.89669C15.1197 5.89669 15.4748 6.04371 15.742 6.31084C16.2936 6.86242 16.2936 7.7595 15.7422 8.31087Z" fill="#004AAD"/>
  </g>
</template>